import type { TableDisplayFieldsProps } from "./TableDisplayFields";

// An external store rather than pane props, because the pane lives above the router and gets its props once, when
// it opens. The list writes its current props here on every render, so the pane follows a view switch made while it
// is open, and Apply calls the list's current onSave: the lists' onSave writes the stored view it closed over, so one
// kept from when the pane opened would write back the filters as they were then, undoing any filter changed since.
export function createTableDisplayFieldsStore(initialListProps: TableDisplayFieldsProps) {
    let listProps = initialListProps;
    const listeners = new Set<() => void>();

    return {
        getListProps: () => listProps,
        subscribe: (listener: () => void) => {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        setListProps: (next: TableDisplayFieldsProps) => {
            listProps = next;
            listeners.forEach((listener) => listener());
        },
    };
}

export type TableDisplayFieldsStore = ReturnType<typeof createTableDisplayFieldsStore>;
